// extracted by mini-css-extract-plugin
export var footerAllRights = "FooterAllRights-module--footerAllRights--WrW1m";
export var footerAllRightsHideOnDesktop = "FooterAllRights-module--footerAllRightsHideOnDesktop--5hPnb";
export var footerAllRightsHideOnMobile = "FooterAllRights-module--footerAllRightsHideOnMobile--fvzPw";